/**
 * FissalOnboarding.jsx — first-run modal that introduces the hint
 * system (#142). Shown once on initial visit; dismissing or picking an
 * intensity flips the persistent flag.
 */
import { Show, createSignal, onMount } from 'solid-js';
import { Portal } from 'solid-js/web';
import { hints, HINT_LEVELS } from '../lib/hintsStore.js';
import { EMOJI } from '../lib/emoji.js';
import './FissalOnboarding.css';

const LEVEL_LABELS = { off: 'Off', low: 'Low', high: 'High' };

export default function FissalOnboarding() {
  const [open, setOpen] = createSignal(false);

  onMount(() => {
    if (!hints.onboarded()) {
      // Slight delay so the gear animation lands after the dashboard
      // paints; avoids competing with first-paint jank.
      setTimeout(() => setOpen(true), 400);
    }
  });

  function pick(level) {
    hints.setIntensity(level);
    hints.markOnboarded();
    setOpen(false);
  }

  function dismiss() {
    hints.markOnboarded();
    setOpen(false);
  }

  return (
    <Show when={open()}>
      <Portal>
        <div class="v2-fissal-ob__backdrop" role="dialog" aria-modal="true" aria-labelledby="v2-fob-title">
          <div class="v2-fissal-ob">
            <div class="v2-fissal-ob__gear-wrap">
              <div class="v2-fissal-ob__gear" />
              <div class="v2-fissal-ob__inner-ring" />
              <span class="v2-fissal-ob__face" aria-hidden="true">{EMOJI.ai}</span>
            </div>
            <div id="v2-fob-title" class="v2-fissal-ob__title">Hint system online</div>
            <div class="v2-fissal-ob__msg">
              Hover anything in the v2 UI to see a quick hint about what
              it does. You can dial that down — or off — any time from
              <em> Menu → Settings → Hints</em>.
            </div>
            <div class="v2-fissal-ob__intensity" role="group" aria-label="Hint intensity">
              {HINT_LEVELS.map((lvl) => (
                <button
                  type="button"
                  class={'v2-fissal-ob__intensity-btn' + (hints.intensity() === lvl ? ' is-active' : '')}
                  classList={{ 'is-active': hints.intensity() === lvl }}
                  onClick={() => pick(lvl)}
                >{LEVEL_LABELS[lvl]}</button>
              ))}
            </div>
            <button type="button" class="v2-fissal-ob__close" onClick={dismiss}>
              Got it
            </button>
          </div>
        </div>
      </Portal>
    </Show>
  );
}
